import { render, staticRenderFns } from "./FaultRecordDialog.vue?vue&type=template&id=4e312b5a&scoped=true&"
import script from "./FaultRecordDialog.vue?vue&type=script&lang=js&"
export * from "./FaultRecordDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e312b5a",
  null
  
)

export default component.exports